import EntityService from '@/services/EntityService'
import { Subcontractor } from '@/models/subcontractor'
import BillService from './BillService'
import FirebaseService from './FirebaseService'
import { collectionGroup, getDocs, query, where } from 'firebase/firestore'
import { WorkOrder, workOrderConverter } from '@/models/workOrder'

export default class SubcontractorService extends EntityService<Subcontractor> {
  constructor() {
    super({ collectionName: 'subcontractors' })
  }

  async getAllSubs(): Promise<Subcontractor[]> {
    // @todo: must run a migration to set isCompany to false for old subcontractors
    // return this.find_by('isCompany', '==', false)
    return this.find_by('trade', '!=', '')
  }

  async getAllCompanies(): Promise<Subcontractor[]> {
    return this.find_by('isCompany', '==', true)
  }

  async getComapny(companyId: string) {
    return await this.find(companyId)
  }

  async getWorkOrders(subcontractorId: string) {
    const db = await FirebaseService.firestore()
    const collectionRef = collectionGroup(db, 'workOrders')
    const querySnapshot = query(collectionRef, where('vendorId', '==', subcontractorId)).withConverter(workOrderConverter)

    return (await getDocs(querySnapshot)).docs.map(doc => doc.data()) as WorkOrder[]
  }

  async getBills(subcontractorId: string) {
    const billService = new BillService()
    return billService.find_by('payee', '==', subcontractorId)
  }
}
